import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../elements-modal/modal';
import { ProjectModalCreate } from './project-modal-create';
import { ProjectModalSuccess } from './project-modal-success';
import { ProjectModalList } from './project-modal-list';
import { ProjectModalShare } from './project-modal-share';
import { ProjectInfoBox } from '../app-projects/project-info-box';
import ProjectThumb from '../partials-thumbnails/project-thumb';
import { FormattedMessage } from 'react-intl';

export class ProjectsModalFlow extends React.Component {
  constructor (props) {
    super(props);

    this.modalBody = this.modalBody.bind(this);
    this.setModalBody = this.setModalBody.bind(this);
    this.renderProjectsModal = this.renderProjectsModal.bind(this);
    this.listingInfo = this.listingInfo.bind(this);
    this.projectInfo = this.projectInfo.bind(this);
    this.listingSavedToOnly1Board = this.listingSavedToOnly1Board.bind(this);

    this.state = {
      modalBody: null
    };
  }

  componentWillMount () {
    const { modalType, projects } = this.props;
    const options = { modalType };
    if ('share' !== modalType && 0 === Object.keys(projects).length) {
      options.modalType = 'create';
    }
    this.setState({
      modalBody: this.renderProjectsModal(options)
    });
  }

  setModalBody (options) {
    this.setState({
      modalBody: this.renderProjectsModal(options)
    });
  }

  listingSavedToOnly1Board (apiRes, reduxRes) {
    const { projects } = this.props;
    // this callback will always be fired when a user saves a listing to 1 project
    // this currently happens in Search (apiRes) and Board Details (reduxRes) page
    // only 1 of these arguments will return at a time.
    const res = apiRes ? apiRes : reduxRes;
    let attachmentProjectID;
    if (apiRes) {
      attachmentProjectID = _.get(res[0], 'project_id', null);
    } else {
      const { listingSavedToOnly1Board = {} } = res;
      attachmentProjectID = _.head(listingSavedToOnly1Board.projectIDs);
    }

    this.setModalBody({
      modalType: 'share',
      openModal: this.openInviteModal,
      newProject: _.find(projects, { '_id': attachmentProjectID })
    });
  }

  listingInfo () {
    const {
      listing: {
        images,
        number_guests,
        title,
        neighborhood,
        city
      }
    } = this.props;

    const [coverImage] = images;
    const coverImageId = coverImage.external_id;


    const infoBox = () => {
      return (
        <div className="d-xs-none d-sm-block">
          <h5 className="title">{title}</h5>
          <div >
            <ul className="list-inline text-small">
              <li className="capitalize ellipsis text-gray-dark v-center">      
                {neighborhood || city}
              </li>
              {number_guests && (
                <li className="v-center text-gray-dark">
                  <i style={{ paddingRight: '4px' }} className="ico ico-md icon-attendees" />
                  <span>{ number_guests }</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      );
    };

    return (
      <ProjectThumb
        coverImageId={ coverImageId }
        ratio={1.689}
        widths={[512, 768]}
        alt="Peerspace"
        infoBox={ infoBox }
        noHover
      />
    );
  }

  projectInfo () {
    return (
      <ProjectInfoBox
        project={this.props.project}
        hideEllipsis
      />
    );
  }

  modalBody () {
    const { modalType } = this.props;
    return (
      <div className='flex project-modal-body-container'>
        <div className='d-xs-none d-sm-block listing-thumbnails'>
          <div className='padding-xl-left padding-xl-right padding-xl-top'>
            {'share' === modalType ? this.projectInfo() : this.listingInfo()}
          </div>
        </div>
        <div className='project-modal-body border-left padding-xl-top'>
          {this.state.modalBody.fn()}
        </div>
      </div>
    );
  }

  renderProjectsModal ({ modalType, origin, newProject, projectsFromCreate }) {

    console.log('renderProjectsModal', modalType, origin, newProject, projectsFromCreate)

    const { closeModal } = this.props;
    const whichModal = {
      success: {
        fn: () => (
          <ProjectModalSuccess
            {...this.props}
            newProject={newProject}
            closeModal={closeModal}
          />
        ),
        name: 'success'
      },
      create: {
        fn: () => (
          <ProjectModalCreate
            {...this.props}
            setModalBody={this.setModalBody}
            origin={origin}
            closeModal={closeModal}
            projectsFromCreate={projectsFromCreate}
          />
        ),
        name: 'create'
      },
      list: {
        fn: () => (
          <ProjectModalList
            {...this.props}
            setModalBody={this.setModalBody}
            listingSavedToOnly1Board={this.listingSavedToOnly1Board}
            projectsFromCreate={projectsFromCreate}
          />
        ),
        name: 'list'
      },
      share: {
        fn: () => (
          <ProjectModalShare
            {...this.props}
            project={newProject || _.get(this.props, 'project')}
            closeModal={closeModal}
          />
        ),
        name: 'share'
      }
    };

    return whichModal[modalType];
  }

  render () {
    const { modalBody } = this.state;
    const { closeModal } = this.props;
    const whichModal = modalBody ? `project-modal-${modalBody.name}` : '';
    const successText = () => {
      return (
        <ul className="list-inline">
          <li>
            <i className="ico ico-md icon-yes" />
          </li>
          <li>
            <FormattedMessage
              id="boards.projects_modal_flow.space_saved"
              defaultMessage="Your space was saved to your new board"
            />
          </li>
        </ul>
      );
    };

    return (
      <Modal
        show
        addCloseIcon={ 'success' !== modalBody.name }
        modalType="standard"
        modalID="project-flow-form"
        modalClass={`project-flow ${whichModal} split-form modal-no-padding`}
        modalSize="lg-size"
        body={ this.modalBody() }
        header=""
        footer={null}
        closeBehavior={closeModal}
        banner={'success' === modalBody.name ? { type: 'success', text: successText() } : null}
      />
    );
  }
}

ProjectsModalFlow.propTypes = {
  modalType: PropTypes.string.isRequired,
  project: PropTypes.object,
  listing: PropTypes.object,
  listSave: PropTypes.func,
  createSave: PropTypes.func,
  projects: PropTypes.array,
  closeModal: PropTypes.func
};
